/* eslint-disable */
// This is a generated file. Any changes you make here will be lost once it's re-generated.
// The entries mirror Gamefound.Web.MainApplication.InitialStateKeys - add keys there, not here.

/**
 * @typedef {Object} ApiAnalyticsConfig
 * @property {Object} consent
 * @property {boolean} internalAnalyticsEnabled
 * @property {Object} facebookPixel
 * @property {Object} googleAnalytics
 * @property {Object} googleAds
 * @property {Object} hotjar
 * @property {Object} clarity
 * @property {Object} helpScout
 * @property {Object} externalAnalytics
 * @property {Object} user
 * @property {Object} project
 */

/**
 * @typedef {Object} LanguageSelectorItemModel
 * @property {boolean} isCurrent
 * @property {number} languageID
 * @property {string} languageIsoCode
 * @property {string} languageName
 * @property {string} languageUrl
 */

/**
 * @typedef {Object} CheckoutCurrencyModel
 * @property {number} currencyID
 * @property {string} name
 * @property {number} projectCurrencyID
 * @property {string} shortName
 * @property {string} symbol
 */

/**
 * @typedef {Object} DisplayCurrencyModel
 * @property {number} currencyID
 * @property {string} name
 * @property {number} relativeFactor
 * @property {number} relativeFactorWithCommission
 * @property {number} relativeToCurrencyID
 * @property {string} shortName
 * @property {string} symbol
 */

/**
 * @typedef {Object} FeatureFlagsModel
 * @property {boolean} androidAppEnabled
 * @property {boolean} avatarGeneratorEnabled
 * @property {boolean} celebratoryEffectsEnabled
 * @property {boolean} celebratoryEffectsSpecialUser
 * @property {boolean} darkModeEnabled
 * @property {boolean} featuredProjectCategoriesEnabled
 * @property {boolean} gameSpecificProjectPropertiesEnabled
 * @property {boolean} iosAppEnabled
 * @property {boolean} pushNotificationsEnabled
 * @property {boolean} heroBannersEnabled
 * @property {boolean} launchCampaignBoxEnabled
 */

/**
 * @typedef {Object} RewardCardModel
 * @property {string} anchorRelativeUrl
 * @property {string} backgroundUrl
 * @property {string} deliveryDateRemarks
 * @property {?string} estimatedDeliveryAt
 * @property {boolean} hasDetails
 * @property {boolean} isExposed
 * @property {boolean} isMostPopular
 * @property {?number} purchasedCopiesCount
 * @property {string} additionalInfoUrl
 * @property {boolean} hasInstallmentsAvailable
 * @property {?number} installmentCost
 * @property {?number} installmentMinPayment
 * @property {string} abstract
 * @property {number} categoryID
 * @property {number} effectivePrice
 * @property {boolean} hasLimitedStock
 * @property {boolean} hasRetailerAccess
 * @property {boolean} hasSpecialAccess
 * @property {string} imageUrl
 * @property {boolean} isDigital
 * @property {boolean} isDiscounted
 * @property {boolean} isFeatured
 * @property {string} name
 * @property {number} price
 * @property {boolean} productCanBePurchased
 * @property {string} productCanBePurchasedDescription
 * @property {number} productID
 * @property {number} projectID
 * @property {?number} remainingStockLimit
 * @property {string} url
 * @property {number} productState
 */

/**
 * @typedef {Object} ApiProjectAdditionalSettings
 * @property {boolean} allowNewOrders
 * @property {boolean} hasAccessToLimitedPledgeManager
 * @property {number} pledgeManagerAvailability
 * @property {?string} pledgeManagerSoftCloseDeadline
 * @property {boolean} enableShippingOnlyMode
 */

/**
 * @typedef {Object} ApiProjectContext
 * @property {boolean} canEnableTestMode
 * @property {Object} creator
 * @property {?number} creatorID
 * @property {boolean} guestUserPledgeEnabled
 * @property {boolean} hasProject
 * @property {Object} installmentsSettings
 * @property {boolean} isDccEnabled
 * @property {boolean} isStablePledgeEnabled
 * @property {boolean} isInTestMode
 * @property {?number} paymentProvider
 * @property {Object} project
 * @property {?number} projectID
 * @property {string} projectPhaseChangedAt
 * @property {Object} settings
 * @property {number} shippingCollectionMode
 * @property {?number} snapshotPhase
 * @property {Object} testingContext
 * @property {number} testingPhase
 */

/**
 * @typedef {Object} ProjectFollowerFactsModel
 * @property {number} projectID
 * @property {number} followersCount
 */

/**
 * @typedef {Object} ProjectCurrentStateModel
 * @property {Object} endgameState
 * @property {Object} statistics
 * @property {Object[]} stretchGoals
 */

/**
 * @typedef {Object} ApiProjectTrackingModel
 * @property {Object} googleAds
 */

/**
 * @typedef {Object} ProjectUserStateModel
 * @property {Object} projectUserContext
 */

/**
 * @typedef {Object} ApiPromoItemWithDetails
 * @property {string} productName
 * @property {string} productImageUrl
 * @property {string} productUrl
 * @property {?number} discountAmount
 * @property {?number} productID
 * @property {number} projectID
 * @property {number} promoItemID
 * @property {number} type
 * @property {number} promoItemEligibilityCondition
 */

/**
 * @typedef {Object} ApiUserAdditionalInfo
 * @property {number[]} backedProjectsIDs
 * @property {number[]} followedProjectsIDs
 * @property {number[]} followedUsersIDs
 * @property {string} guestOrderToken
 * @property {Object} userPreferredLocation
 */

/**
 * @typedef {Object} ApiUserContext
 * @property {string} avatarUrl
 * @property {string} avatarThumbUrl
 * @property {boolean} isImpersonated
 * @property {boolean} isAuthenticated
 * @property {Object} user
 */

/**
 * @typedef {Object} InitialState
 * @property {?ApiAnalyticsConfig} analyticsConfig
 * @property {LanguageSelectorItemModel[]} availableLanguages
 * @property {CheckoutCurrencyModel[]} checkoutCurrencies
 * @property {boolean} currencySelectorVisible
 * @property {?number} currentCheckoutCurrencyId
 * @property {DisplayCurrencyModel[]} displayCurrencies
 * @property {?FeatureFlagsModel} featureFlags
 * @property {?RewardCardModel} featuredReward
 * @property {boolean} preventCartLoading
 * @property {?ApiProjectAdditionalSettings} projectAdditionalSettings
 * @property {?ApiProjectContext} projectContext
 * @property {?ProjectFollowerFactsModel} projectFollowerFacts
 * @property {?ProjectCurrentStateModel} projectState
 * @property {?ApiProjectTrackingModel} projectTracking
 * @property {?ProjectUserStateModel} projectUserState
 * @property {?ApiPromoItemWithDetails} promoItemState
 * @property {?ApiUserAdditionalInfo} userAdditionalInfo
 * @property {?ApiUserContext} userContext
 */

const defaults = {
    analyticsConfig: null,
    availableLanguages: [],
    checkoutCurrencies: [],
    currencySelectorVisible: false,
    currentCheckoutCurrencyId: null,
    displayCurrencies: [],
    featureFlags: {"androidAppEnabled":false,"avatarGeneratorEnabled":false,"celebratoryEffectsEnabled":false,"celebratoryEffectsSpecialUser":false,"darkModeEnabled":false,"featuredProjectCategoriesEnabled":false,"gameSpecificProjectPropertiesEnabled":false,"iosAppEnabled":false,"pushNotificationsEnabled":false,"heroBannersEnabled":false,"launchCampaignBoxEnabled":false},
    featuredReward: null,
    preventCartLoading: false,
    projectAdditionalSettings: {"allowNewOrders":false,"hasAccessToLimitedPledgeManager":false,"pledgeManagerAvailability":2,"pledgeManagerSoftCloseDeadline":null,"enableShippingOnlyMode":false},
    projectContext: null,
    projectFollowerFacts: null,
    projectState: {"endgameState":null,"statistics":null,"stretchGoals":null},
    projectTracking: null,
    projectUserState: null,
    promoItemState: null,
    userAdditionalInfo: {"backedProjectsIDs":null,"followedProjectsIDs":null,"followedUsersIDs":null,"guestOrderToken":null,"userPreferredLocation":null},
    userContext: null,
};

/** @type {InitialState} */
const initialState = { ...defaults, ...window.__INITIAL_STATE__ };

export default initialState;
